<template>
    <div
        v-if="isShow"
        class="sunbit-badge d-inline-flex flex-wrap align-items-center px-2 py-1 rounded border"
    >
        <div class="d-flex align-items-center flex-wrap">
            <img
                src="/view/assets/sunbit_logo.png"
                alt="Sunbit Icon"
                class="sunbit-logo mr-1"
            />
            <strong class="mr-1">Sunbit Qualification:</strong>
            <span :class="['badge', statusClass, 'status-text']">{{
                displayStatus
            }}</span>
        </div>
        <div class="d-flex align-items-center flex-wrap">
            <span class="mx-2 d-none d-sm-inline">|</span>
            <strong>Amount: </strong>
            <span class="ml-1">{{ formattedAmount }}</span>
        </div>
        <div class="d-flex align-items-center flex-wrap">
            <span class="mx-2 d-none d-sm-inline">|</span>
            <strong>Exp: </strong>
            <span class="ml-1">{{ formattedExpirationDate }}</span>
        </div>
    </div>
</template>

<script>
import ClientBillings from "@/services/client-billings";

const STATUS = {
    APPROVED: "PREQUAL_APPROVED",
    PENDING: "PENDING",
    REJECTED: "REJECTED"
};

const STATUS_CLASSES = {
    [STATUS.APPROVED]: "badge-success",
    [STATUS.PENDING]: "badge-warning",
    [STATUS.REJECTED]: "badge-danger"
};

export default {
    name: "SunbitStatusBadge",

    props: {
        clientId: {
            type: String,
            required: true,
            validator: value => typeof value === "string" && value.length > 0
        },
        collectedAmount: {
            type: Number,
            required: false,
            default: 0
        },
        isForceShow: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            status: null,
            amount: null,
            expirationDate: null,
            isShow: false,
            isLoading: false,
            error: null,
            resource: null
        };
    },

    computed: {
        statusClass() {
            return STATUS_CLASSES[this.status] || "badge-secondary";
        },

        displayStatus() {
            return this.status === STATUS.APPROVED ? "Approved" : this.status;
        },

        formattedAmount() {
            return this._toCurrency(this.amount, 2);
        },

        formattedExpirationDate() {
            return this._setDateDisplay(this.expirationDate);
        },
        isExpired() {
            if (!this.expirationDate) return true;
            const currentDate = new Date();
            const expirationDate = new Date(this.expirationDate);
            return currentDate > expirationDate;
        },
        isInRangeAmount() {
            return this.collectedAmount > 60 && this.collectedAmount < 10000;
        }
    },

    watch: {
        clientId: {
            immediate: true,
            handler(newId) {
                if (newId) {
                    this.fetchSunbitStatus();
                }
            }
        },
        collectedAmount: {
            immediate: true,
            handler(newAmount) {
                if (this.resource) {
                    this.updateStatusData(this.resource);
                }
            }
        }
    },

    methods: {
        async fetchSunbitStatus() {
            if (this.isLoading) return;

            this.isLoading = true;
            this.error = null;

            try {
                const response = await ClientBillings.getSunbitPreQualificationStatus(
                    this.clientId
                );

                if (response?.message?.code === 200 && response?.resource) {
                    this.resource = response.resource;
                    this.updateStatusData(this.resource);
                }
            } catch (error) {
                this.error = error;
            } finally {
                this.isLoading = false;
            }
        },

        updateStatusData(resource) {
            this.status = resource.status;
            this.amount = resource.approval_amount;
            this.expirationDate = resource.valid_until;
            this.isShow = false;

            if (this.status === STATUS.APPROVED) {
                this.isShow = !this.isExpired;
                if (this.isShow) {
                    if (this.isForceShow) {
                        this.isShow = true;
                    } else if (!this.isInRangeAmount) {
                        this.isShow = false;
                    }
                }
            }
        }
    }
};
</script>

<style scoped>
.sunbit-badge {
    /* background-color: rgb(202 204 222); */
    /* margin-left: 10px; */
    font-size: clamp(10px, 1vw, 11px);
}

.sunbit-logo {
    height: clamp(12px, 1.5vw, 15px);
    width: auto;
}

.badge {
    font-size: clamp(0.75rem, 1vw, 0.85rem);
    white-space: nowrap;
}

.status-text {
    font-size: clamp(10px, 1vw, 11px);
}

@media (max-width: 576px) {
    .sunbit-badge {
        margin-left: 0;
        margin-top: 0.5rem;
    }
}
</style>
